var map = {
	"./arrow-narrow-left.svg": 5996,
	"./bell.svg": 2244,
	"./camera--v2.png": 4143,
	"./circle-check-regular.svg": 8661,
	"./close-icon.png": 3398,
	"./close-white.png": 7190,
	"./created-icon.png": 3659,
	"./credit-card.svg": 1792,
	"./dice-shuffle.svg": 1525,
	"./down-arrow.svg": 407,
	"./edit.svg": 8044,
	"./eye-solid.svg": 2891,
	"./five35-lotto.jpg": 8576,
	"./greenfive35-lotto.jpg": 4265,
	"./greenplaynow.png": 7089,
	"./home-icon.svg": 5518,
	"./home.svg": 2781,
	"./info-icon.png": 3970,
	"./info-icon.svg": 9114,
	"./life-bouy.svg": 3593,
	"./no-cart.png": 6464,
	"./orangeplaynow.png": 5723,
	"./payment-icon.png": 85,
	"./pick1-lotto.jpg": 3809,
	"./pick3small-icon.png": 9547,
	"./pick4-lotto.jpg": 6064,
	"./pick4small-icon.png": 8755,
	"./pick5-lotto.jpg": 1824,
	"./pick5small-icon.png": 3016,
	"./pick6-lotto.jpg": 5061,
	"./pick6small-icon.png": 2131,
	"./plus.svg": 6164,
	"./selected.svg": 8386,
	"./shopping-cart.svg": 6049,
	"./shuffle-arrow.png": 7531,
	"./six49-lotto.jpg": 840,
	"./slip.svg": 7947,
	"./trash-yellow.svg": 287,
	"./trash.svg": 9916,
	"./unknown.svg": 8786,
	"./verify-icon.png": 3184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5203;